<!-- Codes Loading -->
<mat-progress-bar
  *ngIf="loading"
  color="accent"
  class="rds-c-loading-codes"
  [class.has-search]="enableSearch"
  mode="indeterminate"
></mat-progress-bar>
<div *ngIf="enableSearch || enableSort" class="rds-c-code-select-action-container" fxLayout="row" fxLayoutGap="8px">
  <mtna-search-box
    *ngIf="enableSearch; else noSearch"
    fxFlex
    [debounce]="250"
    [ngModel]="searchText"
    (search)="search.emit($event); _scrollToTop()"
  ></mtna-search-box>
  <button
    *ngIf="enableSort"
    [ngSwitch]="sortDirection"
    mat-icon-button
    class="rds-c-code-select-sort-button"
    (click)="_handleCodeSort(sortDirection)"
    [attr.aria-label]="_sortButtonDetails[sortDirection]"
    [matTooltip]="_sortButtonDetails[sortDirection]"
    matTooltipShowDelay="150"
  >
    <mat-icon *ngSwitchCase="'asc'" [svgIcon]="'sortRowAsc'"></mat-icon>
    <mat-icon *ngSwitchCase="'desc'" [svgIcon]="'sortRowDesc'"></mat-icon>
    <mat-icon *ngSwitchDefault [svgIcon]="'sortRowNatural'"></mat-icon>
  </button>
  <ng-template #noSearch>
    <span fxFlex></span>
  </ng-template>
</div>

<!-- Multiple Selections -->
<ng-container *ngIf="selectionType === 'multi'; else singleSelect">
  <p
    *ngIf="_displayedCodes?.length"
    class="rds-c-codes-selected"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    [class.has-search]="enableSearch"
  >
    <span i18n>codes selected: {{ selectedCodes.length }}</span>
    <button *ngIf="(selectedCodes.length || 0) > 0" class="rds-c-clear-selected-codes bracket-effect" (click)="clearSelectedCodes.emit()">
      clear
    </button>
  </p>

  <mat-selection-list
    cdkScrollable
    dense
    [attr.aria-label]="ariaLabel"
    [compareWith]="_compareCodes"
    [ngStyle]="codeListStyles"
    role="listbox"
    (selectionChange)="_handleSelectionListChange($event)"
  >
    <mat-list-option
      *ngFor="let code of _displayedCodes; trackBy: trackByCr"
      role="option"
      [selected]="!!code.uri ? _selectedUris[code.uri] : false"
      [value]="code"
      >{{ code.name || code.label }}</mat-list-option
    >
  </mat-selection-list>
</ng-container>

<!-- Single Selection -->
<ng-template #singleSelect>
  <mat-list cdkScrollable dense [attr.aria-label]="ariaLabel" [ngStyle]="codeListStyles" role="listbox">
    <mat-radio-group [ngModel]="selectedCodes.length ? selectedCodes[0] : null" (ngModelChange)="_handleRadioGroupChange($event)">
      <mat-list-item role="option" *ngFor="let code of _displayedCodes; trackBy: trackByCr">
        <mat-radio-button labelPosition="before" [value]="code">{{ code.name || code.label }}</mat-radio-button>
      </mat-list-item>
    </mat-radio-group>
  </mat-list>
</ng-template>

<mat-paginator
  *ngIf="enablePagination"
  [length]="length"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="[5, 25, 50, 100]"
  (page)="pageChange.emit($event); _scrollToTop()"
></mat-paginator>
